<template>
  <div>
    <div>
      新竹物流包裹材積超過 10 才（長 × 寬 × 高 ÷ 27,000），或單件重量超過 50 kg 時，因貨物較占車廂空間或不易人工搬運，可能需要使用棧板配送。符合其中任一情況，新竹物流會加收「棧板費」。
    </div>
    <div class="mt-4">
      <strong>配送時效說明</strong>
      <div>
        需轉板的貨物，轉板後約 7 個工作天完成配送，實際配送時間依物流安排為準。
      </div>
    </div>
    <div class="mt-4">
      棧板費依配送地區收費如下：
    </div>
    <table class="table-comment mt-1">
      <tr>
        <td width="80">
          北北基
        </td>
        <td>1000 元</td>
      </tr>
      <tr>
        <td>桃竹苗</td>
        <td>1200 元</td>
      </tr>
      <tr>
        <td>中彰投</td>
        <td>1500 元</td>
      </tr>
      <tr>
        <td>雲嘉南</td>
        <td>1800 元</td>
      </tr>
      <tr>
        <td>高高屏</td>
        <td>2000 元</td>
      </tr>
      <tr>
        <td>宜花東</td>
        <td>2200 元</td>
      </tr>
    </table>
  </div>
</template>
<script>
export default {
  props: {
    transport: String,
    addrid: String,
    isPersonal: Boolean,
  }
}
</script>
